import { useState } from 'react';

let uniqueId = 0;

export const useUniqueId = () => {
    const [id] = useState(`rand${uniqueId++}`);

    return id;
}
